<template>
  <div class="apply">

    <div class="apply-top">
      <van-nav-bar title="在线简历">
        <template #left>
          <van-icon name="arrow-left" size="24" @click="goBack"/>
        </template>
        <template #right>
          <van-button plain hairline type="primary" icon="eye-o" size="small"
                      @click="editable = false" v-show="editable === true">预览</van-button>
          <van-button plain hairline type="primary" icon="edit" size="small"
                      @click="editable = true" v-show="editable === false">编辑</van-button>
        </template>
      </van-nav-bar>
    </div>

    <div class="apply-body">
      <van-skeleton :row="3" :loading="loading" :style="{ paddingTop: '16px' }">
        <van-form @submit="beforeSubmit"  ref="resumeForm" scroll-to-error>

          <van-row>
            <van-col class="resume-item">
              <van-icon name="user-o" color="#1989fa" />
              <span style="padding-left: 6px">基本信息</span>
            </van-col>
          </van-row>

          <van-cell-group inset class="resume-card">
            <van-field v-model.trim="resumeInfo['name']" label="姓名" placeholder="请输入姓名" clearable :readonly="editable === false"
                       name="name"
                       :rules="[{ required: true, message: '姓名不能为空' },
                       { pattern: /^([\u4e00-\u9fa5·]{2,20}|[a-zA-Z\s]{2,50})$/,
                       message: '请输入正确的姓名' }]" :required="editable === true"/>

            <van-field v-model="resumeInfo['gender']" label="性别" placeholder="请选择" readonly :is-link="editable === true"
                       @click="showGenderPopup"
                       name="gender"
                       :rules="[{ required: true, message: '性别不能为空' }]" :required="editable === true"/>
            <van-popup v-model:show="isShowGender" round position="bottom">
              <van-picker title="选择性别" :columns="genderOption" @cancel="isShowGender = false" @confirm="setGender"/>
            </van-popup>

            <van-field v-model.trim="resumeInfo['phone']" label="手机号" placeholder="请输入手机号" type="tel" clearable :readonly="editable === false"
                       name="phone"
                       :rules="[{ required: true, message: '手机号不能为空' },
                       { pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
                       message: '请输入正确的手机号' }]" :required="editable === true"/>

            <van-field v-model="resumeInfo['nativePlace']" label="户籍所在地" placeholder="请选择" readonly :is-link="editable === true"
                       @click="showNativePlacePopup"
                       name="nativePlace"
                       :rules="[{ required: true, message: '户籍所在地不能为空' }]" :required="editable === true"/>
            <van-popup v-model:show="isShowNativePlace" round position="bottom">
              <van-area title="选择城市" :area-list="cityOption" :columns-num="2" @cancel="isShowNativePlace = false" @confirm="setNativePlace"/>
            </van-popup>

            <van-field v-model.trim="resumeInfo['email']" label="电子邮箱" placeholder="请输入电子邮箱" clearable :readonly="editable === false"/>

            <van-field v-model="resumeInfo['birthday']" label="出生日期" placeholder="请选择" readonly :is-link="editable === true"
                       @click="showBirthdayPopup"
                       name="birthday"
                       :rules="[{ required: true, message: '出生日期不能为空' }]" :required="editable === true"/>
            <van-popup v-model:show="isShowBirthday" round position="bottom">
              <van-date-picker title="选择年月日" v-model="currentBirthday" type="date"
                               :min-date="minBirthday" :max-date="maxBirthday"
                               @cancel="isShowBirthday = false" @confirm="setBirthday"/>
            </van-popup>

            <van-field v-model="resumeInfo['political']" label="政治面貌" placeholder="请选择" readonly :is-link="editable === true"
                       @click="showPoliticalPopup" />
            <van-popup v-model:show="isShowPolitical" round position="bottom">
              <van-picker title="选择政治面貌" :columns="politicalOption" @cancel="isShowPolitical = false" @confirm="setPolitical"/>
            </van-popup>

            <van-field v-model="resumeInfo['status']" label="工作状态" placeholder="请选择" readonly :is-link="editable === true"
                       @click="showStatusPopup"
                       :rules="[{ required: true, message: '工作状态不能为空' }]" :required="editable === true" />
            <van-popup v-model:show="isShowStatus" round position="bottom">
              <van-picker title="选择工作状态" :columns="statusOption" @cancel="isShowPolitical = false" @confirm="setStatus"/>
            </van-popup>

            <van-field v-model="resumeInfo['city']" label="目前所在地" placeholder="请选择" readonly :is-link="editable === true"
                       @click="showCityPopup"
                       :rules="[{ required: true, message: '目前所在地不能为空' }]" :required="editable === true"/>
            <van-popup v-model:show="isShowCity" round position="bottom">
              <van-area title="选择城市" :area-list="cityOption" :columns-num="2" @cancel="isShowCity = false" @confirm="setCity"/>
            </van-popup>

            <van-field v-model="resumeInfo['salary']" label="期望薪资(K)" readonly>
              <template #right-icon>
                <van-stepper v-model="resumeInfo['salary']" max="50" button-size="22px" v-show="editable === true" />
              </template>
            </van-field>
          </van-cell-group>

          <van-row>
            <van-col class="resume-item">
              <van-icon name="hotel-o" color="#1989fa" />
              <span style="padding-left: 6px">教育经历</span>
            </van-col>
          </van-row>

          <van-cell-group inset class="resume-card" v-for="(experience, index) in resumeInfo['educationExperiences']" :key="index">
            <van-field v-model="experience['school']" label="学校名称" placeholder="请选择" readonly :is-link="editable === true"
                       @click="showSchoolPopup(index)"
                       name="school"
                       :rules="[{ required: true, message: '学校名称不能为空' }]" :required="editable === true"/>
            <van-popup v-model:show="isShowSchool[index]" round position="bottom">
              <van-picker title="选择学校" :columns="schoolFilter" @cancel="isShowSchool[index] = false"
                          @confirm="setSchool($event, 'educationExperiences', index)">
                <template #columns-top>
                  <van-search v-model="schoolName" placeholder="请输入学校名称" @input="searchSchool" clearable @clear="searchSchool" />
                </template>
              </van-picker>
            </van-popup>
            <van-field v-model="experience['major']" label="专业名称" placeholder="请输入专业名称" clearable :readonly="editable === false"
                       name="major"
                       :rules="[{ required: true, message: '专业名称不能为空' }]" :required="editable === true"/>
            <van-field v-model="experience['qualification']" label="学历" placeholder="请选择" readonly :is-link="editable === true"
                       @click="showQualificationPopup(index)"
                       name="qualification"
                       :rules="[{ required: true, message: '学历不能为空' }]" :required="editable === true"/>
            <van-popup v-model:show="isShowQualification[index]" round position="bottom">
              <van-picker title="选择学历" :columns="qualificationOption" @cancel="isShowQualification[index] = false"
                          @confirm="setQualification($event, 'educationExperiences', index)"/>
            </van-popup>
            <van-field v-model="experience['degree']" label="学位" placeholder="请选择" readonly :is-link="editable === true"
                       @click="showDegreePopup(index)" />
            <van-popup v-model:show="isShowDegree[index]" round position="bottom">
              <van-picker title="选择学位" :columns="degreeOption" @cancel="isShowDegree[index] = false"
                          @confirm="setDegree($event, 'educationExperiences', index)"/>
            </van-popup>
            <van-field v-model="experience['startDate']" label="开始日期" placeholder="请选择" readonly :is-link="editable === true"
                       @click="showStartDatePopup('educationExperiences', index)" />
            <van-popup v-model:show="isShowStartDate['educationExperiences'][index]" round position="bottom">
              <van-date-picker title="选择年月日" v-model="currentStartDate" type="date"
                               :min-date="minStartDate" :max-date="maxStartDate"
                               @cancel="isShowStartDate['educationExperiences'][index] = false"
                               @confirm="setStartDate('educationExperiences', index)"/>
            </van-popup>
            <van-field v-model="experience['endDate']" label="结束日期" placeholder="请选择" readonly :is-link="editable === true"
                       @click="showEndDatePopup('educationExperiences', index)" />
            <van-popup v-model:show="isShowEndDate['educationExperiences'][index]" round position="bottom">
              <van-date-picker title="选择年月日" v-model="currentEndDate" type="date"
                               :min-date="minEndDate" :max-date="maxEndDate"
                               @cancel="isShowEndDate['educationExperiences'][index] = false"
                               @confirm="setEndDate('educationExperiences', index)"/>
            </van-popup>
            <van-row justify="center" v-show="editable === true">
              <van-col>
                <van-button class="card-button" plain icon="add-o" type="primary" size="small"
                            @click="addExperience('educationExperiences')">添加教育经历</van-button>
              </van-col>
              <van-col>
                <van-button class="card-button" plain icon="delete-o" type="danger" size="small"
                            @click="removeExperience('educationExperiences', index)" v-show="index > 0">删除</van-button>
              </van-col>
            </van-row>
          </van-cell-group>

          <van-row>
            <van-col class="resume-item">
              <van-icon name="desktop-o" color="#1989fa" />
              <span style="padding-left: 6px">工作经历</span>
            </van-col>
          </van-row>

          <van-cell-group inset class="resume-card" v-for="(experience, index) in resumeInfo['workExperiences']" :key="index">
            <van-field v-model="experience['company']" label="公司名称" placeholder="请输入公司名称" clearable :readonly="editable === false"/>
            <van-field v-model="experience['position']" label="岗位名称" placeholder="请输入岗位名称" clearable :readonly="editable === false"/>
            <van-field v-model="experience['startDate']" label="开始日期" placeholder="请选择" readonly :is-link="editable === true"
                       @click="showStartDatePopup('workExperiences', index)" />
            <van-popup v-model:show="isShowStartDate['workExperiences'][index]" round position="bottom">
              <van-date-picker title="选择年月日" v-model="currentStartDate" type="date"
                               :min-date="minStartDate" :max-date="maxStartDate"
                               @cancel="isShowStartDate['workExperiences'][index] = false"
                               @confirm="setStartDate('workExperiences', index)"/>
            </van-popup>
            <van-field v-model="experience['endDate']" label="结束日期" placeholder="请选择" readonly :is-link="editable === true"
                       @click="showEndDatePopup('workExperiences', index)" />
            <van-popup v-model:show="isShowEndDate['workExperiences'][index]" round position="bottom">
              <van-date-picker title="选择年月日" v-model="currentEndDate" type="date"
                               :min-date="minEndDate" :max-date="maxEndDate"
                               @cancel="isShowEndDate['workExperiences'][index] = false"
                               @confirm="setEndDate('workExperiences', index)"/>
            </van-popup>
            <van-field v-model="experience['description']" label="工作内容" placeholder="请输入" clearable :readonly="editable === false"
                       type="textarea" rows="1" autosize maxlength="800" show-word-limit/>
            <van-row justify="center" v-show="editable === true">
              <van-col>
                <van-button class="card-button" plain icon="add-o" type="primary" size="small"
                            @click="addExperience('workExperiences')">添加工作经历</van-button>
              </van-col>
              <van-col>
                <van-button class="card-button" plain icon="delete-o" type="danger" size="small"
                            @click="removeExperience('workExperiences', index)" v-show="index > 0">删除</van-button>
              </van-col>
            </van-row>
          </van-cell-group>

          <van-row>
            <van-col class="resume-item">
              <van-icon name="friends-o" color="#1989fa" />
              <span style="padding-left: 6px">项目经历</span>
            </van-col>
          </van-row>

          <van-cell-group inset class="resume-card" v-for="(experience, index) in resumeInfo['projectExperiences']" :key="index">
            <van-field v-model="experience['name']" label="项目名称" placeholder="请输入项目名称" clearable :readonly="editable === false"/>
            <van-field v-model="experience['role']" label="担任角色" placeholder="请输入担任角色" clearable :readonly="editable === false"/>
            <van-field v-model="experience['description']" label="项目描述" placeholder="请输入" clearable :readonly="editable === false"
                       type="textarea" rows="1" autosize maxlength="800" show-word-limit/>
            <van-row justify="center" v-show="editable === true">
              <van-col>
                <van-button class="card-button" plain icon="add-o" type="primary" size="small"
                            @click="addExperience('projectExperiences')">添加项目经历</van-button>
              </van-col>
              <van-col>
                <van-button class="card-button" plain icon="delete-o" type="danger" size="small"
                            @click="removeExperience('projectExperiences', index)" v-show="index > 0">删除</van-button>
              </van-col>
            </van-row>
          </van-cell-group>

          <van-row>
            <van-col class="resume-item">
              <van-icon name="newspaper-o" color="#1989fa" />
              <span style="padding-left: 6px">电子版简历</span>
            </van-col>
          </van-row>

          <van-cell-group inset class="resume-picture">
            <van-uploader v-model="electronic" multiple :max-count="10" upload-text="最多可以上传十个文件" upload-icon="newspaper-o" accept=""
                          :disabled="editable === false" :deletable="editable === true" :show-upload="editable === true" />
          </van-cell-group>

          <van-row>
            <van-col class="resume-item">
              <van-icon name="smile-o" color="#1989fa" />
              <span style="padding-left: 6px">登记照</span>
            </van-col>
          </van-row>

          <van-cell-group inset class="resume-picture">
            <van-uploader v-model="photo" :max-count="1" upload-text="最多可以上传一张图片" upload-icon="photo-o"
                          :disabled="editable === false" :deletable="editable === true" :show-upload="editable === true" />
          </van-cell-group>

          <van-row>
            <van-col class="resume-item">
              <van-icon name="award-o" color="#1989fa" />
              <span style="padding-left: 6px">资格证书</span>
            </van-col>
          </van-row>

          <van-cell-group inset class="resume-picture">
            <van-uploader v-model="certificate" multiple :max-count="10" upload-text="最多可以上传十个文件" upload-icon="award-o" accept=""
                          :disabled="editable === false" :deletable="editable === true" :show-upload="editable === true" />
          </van-cell-group>

          <van-row>
            <van-col class="resume-item">
              <van-icon name="good-job-o" color="#1989fa" />
              <span style="padding-left: 6px">评价与规划</span>
            </van-col>
          </van-row>

          <van-cell-group inset class="resume-card">
            <van-field v-model="resumeInfo['selfAssessment']" label="自我评价" placeholder="请输入" clearable :readonly="editable === false"
                       type="textarea" rows="1" autosize maxlength="200" show-word-limit/>

            <van-field v-model="resumeInfo['careerPlan']" label="职业规划" placeholder="请输入" clearable :readonly="editable === false"
                       type="textarea" rows="1" autosize maxlength="200" show-word-limit/>
          </van-cell-group>

          <van-button class="resume-button" type="primary" round block native-type="submit" v-show="editable === true">保存</van-button>
        </van-form>
      </van-skeleton>

      <van-dialog v-model:show="isShowDialog" @confirm="closeDialog" @close="closeDialog"
                  title="简历保存成功" :message="dialogMessage" allow-html/>
    </div>

  </div>
</template>

<script>
import {ref} from "vue";
import {areaList} from '@vant/area-data';
import {addResume, getSchoolOption} from "@/api";
import {showConfirmDialog, showDialog, showNotify} from "vant";
import {selectDictText} from "@/api/common";

export default {
  name: "ResumeForm",
  data() {
    return {
      editable: undefined,
      loading: true,
      isShowDialog: false,
      dialogMessage: undefined,
      second: 2, // 倒计时秒数
      timer: null, // 计时器
      resumeInfo: {},
      isShowGender: false,
      genderOption: [
        { text: '女', value: '女' },
        { text: '男', value: '男' },
      ],
      isShowBirthday: false,
      currentBirthday: undefined,
      minBirthday: undefined,
      maxBirthday: undefined,
      isShowPolitical: false,
      politicalOption: [
        { text: '共产党员', value: '共产党员' },
        { text: '共青团员', value: '共青团员' },
        { text: '群众', value: '群众' },
      ],
      isShowStatus: false,
      statusOption: [
        { text: '已签约/正式就业', value: '已签约/正式就业' },
        { text: '实习（含试用期）', value: '实习（含试用期）' },
        { text: '待岗', value: '待岗' },
        { text: '灵活就业/兼职', value: '灵活就业/兼职' },
      ],
      isShowNativePlace: false,
      isShowCity: false,
      cityOption: areaList,
      isShowSchool: [],
      schoolOption: [],
      isShowQualification: [],
      schoolName: '',
      schoolFilter: [],
      qualificationOption: [
        { text: '本科', value: '本科', disabled: false },
        { text: '硕士', value: '硕士', disabled: false },
        { text: '博士', value: '博士', disabled: false },
      ],
      isShowDegree: [],
      degreeOption: [
        { text: '无', value: '无' },
        { text: '学士', value: '学士', disabled: false },
        { text: '硕士', value: '硕士', disabled: false },
        { text: '博士', value: '博士', disabled: false },
      ],
      isShowStartDate: [],
      currentStartDate: undefined,
      minStartDate: undefined,
      maxStartDate: undefined,
      isShowEndDate: [],
      currentEndDate: undefined,
      minEndDate: undefined,
      maxEndDate: undefined,

      photo: [],
      certificate: [],
      electronic: [],

      form: undefined,
    }
  },
  mounted() {
    this.isShowDialog = false;
    this.dialogMessage = `3秒后自动跳转回<br>职位详情页`;

    let city_list = this.cityOption['city_list'];
    let city_code = [];
    for (let code in city_list) {
      if (city_list[code].includes('直辖')) {
        city_code.push(code.slice(0, 3));
        delete city_list[code];
      } else if (city_list[code] === '县') {
        delete city_list[code];
      }
    }
    let county_list = this.cityOption['county_list'];
    for (let code in county_list) {
      if (city_code.includes(code.slice(0, 3))) {
        city_list[code] = county_list[code];
      }
    }

    let resumeInfo = window.sessionStorage.getItem('userResume');
    if (resumeInfo === null || resumeInfo === undefined || resumeInfo === 'undefined') {
      this.editable = true;
    } else {
      this.editable = false;
      this.resumeInfo = JSON.parse(resumeInfo);
    }

    this.isShowGender = false;

    this.isShowBirthday = false;

    this.isShowPolitical = false;

    if (this.resumeInfo['educationExperiences'] === null || this.resumeInfo['educationExperiences'] === undefined) {
      this.resumeInfo['educationExperiences'] =[];
      this.resumeInfo['educationExperiences'].push(
          { school: '', major: '', startDate: '', endDate: '', qualification: '', degree: '' }
      );
    } else {
      this.resumeInfo['educationExperiences'] = JSON.parse(this.resumeInfo['educationExperiences']);
    }

    this.isShowSchool = [];
    getSchoolOption().then((res) => {
      if (res.code === 200) {
        this.schoolOption = res.data;
        this.schoolFilter = res.data;
      }
    });
    this.schoolName = '';

    this.isShowQualification = [];

    this.isShowDegree = [];

    this.isShowStartDate['educationExperiences'] = [];
    this.isShowEndDate['educationExperiences'] = [];

    if (this.resumeInfo['workExperiences'] === null || this.resumeInfo['workExperiences'] === undefined) {
      this.resumeInfo['workExperiences'] = [];
      this.resumeInfo['workExperiences'].push(
          { company: '', position: '', startDate: '', endDate: '', description: '' }
      );
    } else {
      this.resumeInfo['workExperiences'] = JSON.parse(this.resumeInfo['workExperiences']);
    }

    this.isShowStartDate['workExperiences'] = [];
    this.isShowEndDate['workExperiences'] = [];

    if (this.resumeInfo['projectExperiences'] === null || this.resumeInfo['projectExperiences'] === undefined) {
      this.resumeInfo['projectExperiences'] =[];
      this.resumeInfo['projectExperiences'].push(
          { name: '', role: '', description: '' }
      );
    } else {
      this.resumeInfo['projectExperiences'] = JSON.parse(this.resumeInfo['projectExperiences']);
    }

    if (this.resumeInfo['photo'] === null || this.resumeInfo['photo'] === undefined) {
      this.photo = [];
    } else {
      this.photo = JSON.parse(this.resumeInfo['photo']);
    }

    if (this.resumeInfo['certificate'] === null || this.resumeInfo['certificate'] === undefined) {
      this.certificate = [];
    } else {
      this.certificate = [];
      let certificate = JSON.parse(this.resumeInfo['certificate']);
      for (let i = 0; i < certificate.length; i++) {
        let item = {};
        item['url'] = certificate[i]['url'];
        item['file'] = new File([], certificate[i]['name'], {});
        this.certificate.push(item);
      }
    }

    if (this.resumeInfo['electronic'] === null || this.resumeInfo['electronic'] === undefined) {
      this.electronic = [];
    } else {
      this.electronic = [];
      let electronic = JSON.parse(this.resumeInfo['electronic']);
      for (let i = 0; i < electronic.length; i++) {
        let item = {};
        item['url'] = electronic[i]['url'];
        item['file'] = new File([], electronic[i]['name'], {});
        this.electronic.push(item);
      }
    }

    this.form = undefined;

    this.loading = false;

    // 添加 popstate 事件监听
    window.history.pushState(null, null, window.location.href);
    window.addEventListener('popstate', this.onPopState);
  },
  beforeUnmount() {
    window.removeEventListener('popstate', this.onPopState);
  },
  methods: {
    onPopState() {
      window.history.pushState(null, null, window.location.href);
      this.goBack();
    },
    goBack() {
      let isChange = false;
      let keys = Object.keys(this.resumeInfo);
      if (keys.length > 0) {
        let resumeInfo = window.sessionStorage.getItem('userResume');
        if (resumeInfo === null || resumeInfo === undefined || resumeInfo === 'undefined') {
          for (let i = 0; i < keys.length; i++) {
            let key = keys[i];
            if (key === 'createtime' || key === 'updatetime') {
              continue;
            }
            if (key === 'educationExperiences' || key === 'workExperiences' || key === 'projectExperiences') {
              for (let j = 0; j < this.resumeInfo[key].length; j++) {
                let experience = this.resumeInfo[key][j];
                for (let item in experience) {
                  if (experience[item] !== '') {
                    isChange = true;
                    break;
                  }
                }
              }
            } else if (key === 'salary') {
              if (this.resumeInfo[key] !== '1') {
                isChange = true;
                break;
              }
            } else {
              if (this.resumeInfo[key] !== '') {
                isChange = true;
                break;
              }
            }
          }
        } else {
          resumeInfo = JSON.parse(resumeInfo);
          for (let i = 0; i < keys.length; i++) {
            let key = keys[i];
            if (key === 'createtime' || key === 'updatetime') {
              continue;
            }
            if (key === 'educationExperiences' || key === 'workExperiences' || key === 'projectExperiences') {
              for (let j = 0; j < this.resumeInfo[key].length; j++) {
                let experience = JSON.parse(resumeInfo[key])[j];
                for (let item in experience) {
                  if (experience[item] !== this.resumeInfo[key][j][item]) {
                    isChange = true;
                    break;
                  }
                }
              }
            } else {
              if (this.resumeInfo[key] !== resumeInfo[key]) {
                isChange = true;
                break;
              }
            }
          }
        }
      }
      if (isChange === false) {
        let jump = window.sessionStorage.getItem('jump');
        if (jump) {
          this.$router.push({path: jump});
        } else {
          this.$router.push('/HomePage');
        }
      } else {
        showConfirmDialog({
          message: '修改内容还未保存，是否确认关闭？',
        }).then(() => {
          // on close
          let jump = window.sessionStorage.getItem('jump');
          if (jump) {
            this.$router.push({path: jump});
          } else {
            this.$router.push('/HomePage');
          }
        }).catch(() => {
          // on cancel
        });
      }
    },
    showGenderPopup() {
      if (this.editable === true) {
        this.isShowGender = true;
      }
    },
    setGender(option) {
      let values = option.selectedValues;
      this.resumeInfo['gender'] = values[0];
      this.isShowGender = false;
    },
    showBirthdayPopup() {
      if (this.editable === true) {
        let year = new Date().getFullYear();
        this.minBirthday = new Date();
        this.minBirthday.setFullYear(year - ref(50).value);
        this.maxBirthday = new Date();
        this.maxBirthday.setFullYear(year - ref(18).value);
        let month = String(new Date().getMonth() + 1).padStart(2, '0');
        let day = String(new Date().getDate()).padStart(2, '0');
        if (this.currentBirthday === undefined || this.currentBirthday === null) {
          this.currentBirthday = ref([String(year), month, day]);
        }
        this.isShowBirthday = true;
      }
    },
    setBirthday() {
      this.resumeInfo['birthday'] = this.currentBirthday[0] + '-' + this.currentBirthday[1] + '-' + this.currentBirthday[2];
      this.isShowBirthday = false;
      this.currentBirthday = undefined;
    },
    showPoliticalPopup() {
      if (this.editable === true) {
        this.isShowPolitical = true;
      }
    },
    setPolitical(option) {
      let values = option.selectedValues;
      this.resumeInfo['political'] = values[0];
      this.isShowPolitical = false;
    },
    showStatusPopup() {
      if (this.editable === true) {
        this.isShowStatus = true;
      }
    },
    setStatus(option) {
      let values = option.selectedValues;
      this.resumeInfo['status'] = values[0];
      this.isShowStatus = false;
    },
    showNativePlacePopup() {
      if (this.editable === true) {
        this.isShowNativePlace = true;
      }
    },
    setNativePlace(option) {
      let options = option.selectedOptions;
      this.resumeInfo['nativePlace'] = options[1].text;
      this.isShowNativePlace = false;
    },
    showCityPopup() {
      if (this.editable === true) {
        this.isShowCity = true;
      }
    },
    setCity(option) {
      let options = option.selectedOptions;
      this.resumeInfo['city'] = options[1].text;
      this.isShowCity = false;
    },
    showSchoolPopup(index) {
      if (this.editable === true) {
        this.isShowSchool[index] = true;
      }
    },
    searchSchool() {
      this.schoolFilter = this.schoolOption.filter((school) => {
        return school.text.includes(this.schoolName);
      });
    },
    setSchool(option, key, index) {
      let values = option.selectedValues;
      this.resumeInfo[key][index]['school'] = values[0];
      this.isShowSchool[index] = false;
      this.schoolName = '';
    },
    schoolNameFormat(value) {
      let schoolName = selectDictText(this.schoolOption, value);
      return schoolName;
    },
    showQualificationPopup(index) {
      if (this.editable === true) {
        this.isShowQualification[index] = true;
      }
    },
    setQualification(option, key, index) {
      let values = option.selectedValues;
      this.resumeInfo[key][index]['qualification'] = values[0];
      this.isShowQualification[index] = false;
    },
    showDegreePopup(index) {
      if (this.editable === true) {
        this.isShowDegree[index] = true;
      }
    },
    setDegree(option, key, index) {
      let values = option.selectedValues;
      this.resumeInfo[key][index]['degree'] = values[0];
      this.isShowDegree[index] = false;
    },
    showStartDatePopup(key, index) {
      if (this.editable === true) {
        let endDate = this.resumeInfo[key][index]['endDate'];
        let year = new Date().getFullYear();
        this.minStartDate = new Date();
        this.minStartDate.setFullYear(year - ref(32).value);
        if (endDate === undefined || endDate === null || endDate === '') {
          this.maxStartDate = new Date();
        } else {
          this.maxStartDate = new Date(endDate);
          this.maxStartDate.setDate(this.maxStartDate.getDate() - 1);
        }
        let month = String(new Date().getMonth() + 1).padStart(2, '0');
        let day = String(new Date().getDate()).padStart(2, '0');
        if (this.currentStartDate === undefined || this.currentStartDate === null) {
          this.currentStartDate = ref([String(year), month, day]);
        }
        this.isShowStartDate[key][index] = true;
      }
    },
    setStartDate(key, index) {
      this.resumeInfo[key][index]['startDate'] = this.currentStartDate[0] + '-' + this.currentStartDate[1] + '-' + this.currentStartDate[2];
      this.isShowStartDate[key][index] = false;
      this.currentStartDate = undefined;
    },
    showEndDatePopup(key, index) {
      if (this.editable === true) {
        let startDate = this.resumeInfo[key][index]['startDate'];
        let year = new Date().getFullYear();
        if (startDate === undefined || startDate === null || startDate === '') {
          this.minEndDate = new Date();
          this.minEndDate.setFullYear(year - ref(32).value);
        } else {
          this.minEndDate = new Date(startDate);
          this.minEndDate.setDate(this.minEndDate.getDate() + 1);
        }
        this.maxEndDate = new Date();
        this.maxEndDate.setFullYear(year + ref(1).value);
        let month = String(new Date().getMonth() + 1).padStart(2, '0');
        let day = String(new Date().getDate()).padStart(2, '0');
        if (this.currentEndDate === undefined || this.currentEndDate === null) {
          this.currentEndDate = ref([String(year), month, day]);
        }
        this.isShowEndDate[key][index] = true;
      }
    },
    setEndDate(key, index) {
      this.resumeInfo[key][index]['endDate'] = this.currentEndDate[0] + '-' + this.currentEndDate[1] + '-' + this.currentEndDate[2];
      this.isShowEndDate[key][index] = false;
      this.currentEndDate = undefined;
    },
    addExperience(key) {
      let item;
      if (key === 'educationExperiences') {
        item = { school: '', major: '', startDate: '', endDate: '', qualification: '', degree: '' };
      }
      if (key === 'workExperiences') {
        item = { company: '', position: '', startDate: '', endDate: '', description: '' };
      }
      if (key === 'projectExperiences') {
        item = { name: '', role: '', description: '' };
      }
      this.resumeInfo[key].push(item);
    },
    removeExperience(key, index) {
      this.resumeInfo[key].splice(index, 1);
    },
    closeDialog() {
      this.isShowDialog = false;
      let jump = window.sessionStorage.getItem('jump');
      this.$router.replace({path: jump});
    },
    beforeSubmit() {
      if (this.electronic.length < 1) {
        showDialog({
          message: '必须上传电子版简历。',
        }).then(() => {
        });
      } else {
        this.handleSubmit();
      }
    },
    handleSubmit() {
      this.form = new FormData();
      let keys = Object.keys(this.resumeInfo);
      for (let i = 0; i < keys.length; i++) {
        let key = keys[i];
        if (key === 'createtime' || key === 'updatetime') {
          continue;
        }
        if (key === 'educationExperiences' || key === 'workExperiences' || key === 'projectExperiences') {
          this.form.append(key, JSON.stringify(this.resumeInfo[key]));
        } else {
          this.form.append(key, this.resumeInfo[key]);
        }
      }

      for (let i = 0; i < this.photo.length; i++) {
        this.form.append('photoFiles', this.photo[i].file);
      }

      for (let i = 0; i < this.certificate.length; i++) {
        this.form.append('certificateFiles', this.certificate[i].file);
      }

      for (let i = 0; i < this.electronic.length; i++) {
        this.form.append('electronicFiles', this.electronic[i].file);
      }

      addResume(this.form).then((res) => {
        if (res.code === 200) {
          //简历新增成功
          window.sessionStorage.setItem('userResume', JSON.stringify(res.data));
          this.editable = false;
          //跳转页面
          let jump = window.sessionStorage.getItem('jump');
          if (jump) {
            this.isShowDialog = true;
            this.timer = setInterval(() => {
              this.dialogMessage = `${this.second}秒后自动跳转回<br>职位详情页`;
              if (this.second >= 0) {
                this.second -= 1;
              } else if (this.second < 0) {
                this.closeDialog();
                clearInterval(this.timer);
                this.timer = null;
              }
            }, 1000);
            // setTimeout(() => {
            //   this.closeDialog();
            // }, 3000);
          } else {
            showNotify({ type: 'success', message: '简历保存成功！', position: 'bottom' });
          }
        } else {
          showNotify({ type: 'danger', message: '服务器繁忙，请稍后再试。', position: 'bottom' });
        }
      });

    },
  }
}
</script>

<style scoped>
.apply {
  width:100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.apply-top {
}

.apply-body {
  flex: 1;
  overflow-y: scroll;
  padding: 0 16px 20px;
}

.resume-item {
  font-size: 20px;
  line-height: 24px;
  padding: 24px 8px 12px 8px;
}

.resume-button {
  font-size: 18px;
  margin-top: 20px;
}

.resume-card {
  margin: 0px 0 10px 0;
  border: 1px solid rgb(224, 224, 224);
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(100, 101, 102, .12);
}

.card-button {
  margin: 20px 10px 10px 10px;
}

</style>